// Static inspiration images removed — media comes from WooCommerce product attachments.

export const inspirationImages = {};
